import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import css from "./saas_admin_header.less";

const SaasAdminHeader = ({ title, subTitle, fixedWidth = true }) => (
  <div className={classNames(css.saasAdminHeader, { [css.fixedWidth]: fixedWidth })}>
    <h1>{title}</h1>
    {subTitle && <h2>{subTitle}</h2>}
  </div>
);

SaasAdminHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  fixedWidth: PropTypes.bool
};

export default SaasAdminHeader;
